import React, { useState } from "react";
import PortableText from "./portableText";
import clientConfig from "../../client-config";
import * as styles from './whyHomestaHero.module.css';

import { getGatsbyImageData } from "gatsby-source-sanity";
import { GatsbyImage } from "gatsby-plugin-image";
const maybeImage = illustration => {
  let img = null;
  if (illustration && illustration.image && illustration.image.asset && !illustration.disabled) {
    const imageData = getGatsbyImageData(
      illustration.image,
      { maxWidth: 960 },
      clientConfig.sanity
    );

    img = (
      <GatsbyImage
        image={imageData}
        alt={illustration.image.alt}
      />
    );
  }
  return img;
};

function WhyHomestaHero(props) {

    const featuredimg = maybeImage(props.featuredImage);
    const sectionimg = maybeImage(props.sectionImage);

    console.log(props.videoEmbedCode);

    return (
        <div className={styles.sectionWhyHomestaHero}>

            <div className={styles.heroWrap}>
                <div className={styles.heroContainer}>
                    <div className={styles.bgCircle}>
                        <img src={require('../images/hero_circle.png').default} alt="Download in Google Play" />
                    </div>
                    <div className={styles.featuredImageWrap}>
                        {featuredimg}
                    </div>
                    <div className={styles.heroContentWrap}>
                        <h1>
                            <PortableText blocks={props.heading} />
                        </h1>
                        <div className={styles.mobileImage}>
                            {featuredimg}
                        </div>
                        <div className={styles.contentWrap}>
                            <PortableText blocks={props.content} />
                        </div>
                        {
                            (props.hasSearchBar) ? 
                                <div className={styles.tagSearchBar}>
                                    <i class="fas fa-search"></i>
                                    <input type="text" name="address_search" placeholder="Address" required />
                                    <a href="#" className={styles.addressSearchBtn}>
                                        <span class="inline-block align-middle">Search</span>
                                        <img class="inline-block align-middle" src={require('../images/arrow-right-white.png').default} alt="Right arrow" />
                                    </a>
                                </div>
                                : ``
                        }
                        <div className={styles.ctaWrap}>
                            {
                                (props.appStoreLink) ? 
                                <a href={props.appStoreLink} target="_blank">
                                    <img src={require('../images/app_store_2.png').default} alt="Download in App Store" />
                                </a> 
                                : ``
                            }
                            {
                                (props.playStoreLink) ? 
                                <a href={props.playStoreLink} target="_blank">
                                    <img src={require('../images/google_play_2.png').default} alt="Download in Google Play" />
                                </a> 
                                : ``
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div className={styles.preSectionWrap}>
                <div className={styles.sectionContainer}>
                    <h3>{props.sectionTitle}</h3>
                    <div className={styles.videoEmbed}>
                        <PortableText blocks={props.videoEmbedCode} />
                    </div>
                    <div className={styles.sectionContentWrap}>
                        <PortableText blocks={props.sectionContent} />
                    </div>
                </div>
                <div className={styles.sectionBg}></div>
            </div>

        </div>
    );
}

export default WhyHomestaHero;
